const getTenderListBySearchReq = {
  orderASC: true,
  pageNo: 1,
  pageSize: 10,
};

export default getTenderListBySearchReq;
